module.exports = __webpack_public_path__ + "static/media/xiaoyu-lose.f5739e73.png";